import React from 'react';
import { Trigger } from 'framework/hooks/useTrigger';

interface IContext {
	isOpen: boolean;
	open: (documentId: string, historyId?: string) => void;
	trigger: Trigger;
}

export const DocumentEditorDialogContext = React.createContext<IContext>(undefined as any);
